import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import { TGustoReportReq, TUpdateGustoDataReq } from '../types/requests';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function IntegrationsController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.INTEGRATIONS.PAYROLL;

  const getGustoData = <T>(data: { shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/gusto/personnel/data`, requestOptions);
  };

  const updateGustoData = <T>(data: TUpdateGustoDataReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/gusto/personnel/update`, requestOptions);
  };

  const getGustoReport = <T>(data: TGustoReportReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/gusto/csv_report`, requestOptions);
  };

  const getMgmReport = <T>(data: TGustoReportReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/mgm8/csv_report`, requestOptions);
  };

  return {
    getGustoData,
    updateGustoData,
    getGustoReport,
    getMgmReport,
  };
}
